import React, { useRef } from 'react';
import { useSearchReducer } from 'src/pages/consumer/components/DishFirstHeader/store';
import { DesktopSearchWrapper } from '../styles';
import { SearchProps } from '../types';
import { SearchBarContents } from './SearchBarContents';

export const SearchBar: React.FC<SearchProps> = ({ timeZone }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { hide, isShowing, show } = useSearchReducer();
  return (
    <DesktopSearchWrapper isOpen={isShowing} ref={wrapperRef}>
      <SearchBarContents timeZone={timeZone} hideSearch={hide} showSearch={show} isSearchShowing={isShowing} />
    </DesktopSearchWrapper>
  );
};
